import { Observable } from 'rxjs';
import { Task, TaskDetail, TaskFilter, TaskStatus } from '@/app/core/Models/Task';
import { TaskFilterDto } from '@/app/Data/DTO/TasksListDto';

export abstract class ITasksRepository {
  abstract getTasks(filter: TaskFilter, status: TaskStatus): Observable<Task[]>;
  abstract getTasksV2(
    filter: TaskFilterDto, 
    forceRefresh?: boolean,
    sourceComponent?: 'home' | 'tasks'
  ): Observable<{ results: Task[], total: number, status_count: { open: number, 'in-progress': number, done: number, trash: number } }>;
  abstract getTasksByChannelId(
    filter: TaskFilter,
    status: TaskStatus,
    channelId: number
  ): Observable<Task[]>;
  abstract saveTasks(tasks: Task[]): void;
  abstract appendTasks(tasks: Task[]): void;
  abstract saveTask(request: Task): void;
  abstract getLocalTasks(filter: TaskFilter): Observable<Task[]>;
  abstract getLocalTasksV2(filter?: TaskFilterDto): Observable<Task[]>;
  abstract filterTasks(task: Task, filter: TaskFilterDto): Task;
  abstract getLocalTaskById(taskId: number): Observable<Task | undefined>;
  
  // Cache management methods
  abstract invalidateCacheEntry(filter: TaskFilterDto): void;
  abstract invalidateAllCache(): void;
  abstract invalidateCacheByStatus(statuses: TaskStatus[]): void;
  abstract getCacheStats(): { entries: number, oldestEntry: Date | null, newestEntry: Date | null };
}
